var map = {
	"./black/baojingqueren.png": "M0Z6",
	"./blue/baojingqueren.png": "aE9I",
	"./white/baojingqueren.png": "uGnL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4cTt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/baojingqueren\.png$
// module id = 4cTt
// module chunks = 24